import { createBrowserRouter } from "react-router-dom"
import loader from "@/utilities/loader"
import { createElement } from "react"

const routes = [
    {
        path: "",
        element: loader({
            factory: () => import("@/components/templates/AuthorizedLayout"),
            name: "AuthorizedLayout",
            retry: false
        }),
        children: [
            {
                index: true,
                element: loader({
                    factory: () => import("@/components/pages/OverviewPage"),
                    name: "OverviewPage"
                })
            },
            {
                path: "inventory-management",
                element: loader({
                    factory: () => import("@/components/pages/InventoryManagementPage"),
                    name: "InventoryManagementPage"
                })
            },
            {
                path: "artchase",
                element: loader({
                    factory: () => import("@/components/pages/ArtchasePage"),
                    name: "ArtchasePage"
                })
            },
            {
                path: "campaigns/:campaignCode",
                element: loader({
                    factory: () => import("@/components/pages/CampaignBookingManagerPage"),
                    name: "CampaignBookingManagerPage"
                })
            },
            {
                path: "creative-file-upload-manager",
                element: loader({
                    factory: () => import("@/components/pages/CreativeFileUploadManagerPage"),
                    name: "CreativeFileUploadManagerPage"
                })
            },
            {
                path: "customer-manager",
                element: loader({
                    factory: () => import("@/components/pages/CustomerManagerPage"),
                    name: "CustomerManagerPage"
                })
            },
            {
                path: "settings/:slug",
                element: loader({
                    factory: () => import("@/components/pages/SystemSettingPage"),
                    name: "SystemSettingPage"
                })
            }
        ]
    },
    {
        path: "login",
        element: loader({
            factory: () => import("@/components/pages/LoginPage"),
            name: "LoginPage"
        })
    },
    {
        path: "terms-and-conditions",
        element: loader({
            factory: () => import("@/components/pages/TermsConditionPage"),
            name: "TermsConditionPage"
        })
    },
    {
        path: "recovery",
        element: loader({
            factory: () => import("@/components/pages/ForgotPasswordPage"),
            name: "ForgotPasswordPage"
        })
    },
    {
        path: "reset-password/:uidb64/:token",
        element: loader({
            factory: () => import("@/components/pages/ResetPasswordPage"),
            name: "ResetPasswordPage"
        })
    },
    {
        path: "password-setup/:uidb64/:token",
        element: loader({
            factory: () => import("@/components/pages/PasswordSetupPage"),
            name: "PasswordSetupPage"
        })
    },
    {
        path: "*",
        element: loader({
            factory: () => import("@/components/pages/ErrorPage"),
            name: "ErrorPage",
            retry: false
        })
    }
]

for (const route of routes) {
    route.element = createElement(route.element)

    if (route.path !== "*") {
        const component = loader({
            factory: () => import("@/components/pages/ErrorPage"),
            name: "ErrorPage",
            retry: false
        })

        route.errorElement = createElement(component)
    }

    if (!Array.isArray(route.children)) continue

    for (const child of route.children) {
        child.element = createElement(child.element)
    }
}

export default createBrowserRouter(routes)
